import { claimflowApiClient } from './claimflowApiClient';
import type {
  ClaimFlowLoginRequest,
  ClaimFlowLoginResponse,
  ClaimFlowMeResponse,
} from '../auth/types';

export const claimflowAuthService = {
  async login(
    credentials: ClaimFlowLoginRequest,
  ): Promise<ClaimFlowLoginResponse> {
    const response = await claimflowApiClient.post<ClaimFlowLoginResponse>(
      '/claimflow/auth/login',
      credentials,
    );
    return response.data;
  },

  async logout(): Promise<void> {
    await claimflowApiClient.post('/claimflow/auth/logout');
  },

  async me(): Promise<ClaimFlowMeResponse> {
    const response =
      await claimflowApiClient.get<ClaimFlowMeResponse>(
        '/claimflow/auth/me',
      );
    return response.data;
  },

  async getConfig(
    tenantId?: string,
  ): Promise<{ data: { config: Record<string, unknown> } }> {
    // When a tenant identifier (slug or UUID) is supplied, send it as an
    // explicit X-Tenant-ID header. The shared interceptor only fills the
    // header from localStorage when it is absent, so this pre-set header
    // wins and lets anonymous, pre-login config fetches resolve the tenant
    // from the URL slug.
    const config = tenantId
      ? { headers: { 'X-Tenant-ID': tenantId } }
      : undefined;
    const response = await claimflowApiClient.get<{ data: { config: Record<string, unknown> } }>(
      '/claimflow/config',
      config,
    );
    return response.data;
  },
};
